// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stripe_token: 'pk_test_51MNHOLSI7QcxpokeLnCAo05akJJiPdbd4tcrqNZJBLcKAXmuxpONBOyzFuGXhSxLf1LT6NynxCzdwWFpL4xvN07J00xRwb4Rf9',
  paypal_token: 'PAYPAL_TOKEN',
  mediaUrl:'https://lendensoft.s3.ap-northeast-1.amazonaws.com/',
//apiUrl:'https://localhost:44330/'
     apiUrl:'https://apiecom.timessquarebook.com/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
